export class EraserTool {
    constructor(sketch) {
        this.sketch = sketch;
        this.selected = new Set();
        this.onErased = null;
        this.options = {
            onlyOwned: false,
        };
        this.sketch.scope.activate();
        this.tool = new this.sketch.scope.Tool();
        this.tool.minDistance = 3;
        this.tool.onMouseDown = (ev) => this.onMouseDown(ev);
        this.tool.onMouseDrag = (ev) => this.onMouseDrag(ev);
        this.tool.onMouseUp = (ev) => this.onMouseUp(ev);
        this.tool.onKeyUp = (ev) => this.onKeyUp(ev);
    }
    enable() {
        this.tool.activate();
    }
    disable() {
        this.sketch.noTool.activate();
    }
    erase(items) {
        var _a;
        this.sketch.scope.activate();
        for (const { id } of items) {
            if (id) {
                (_a = this.sketch.scope.project.getItem({ data: { id } })) === null || _a === void 0 ? void 0 : _a.remove();
            }
        }
    }
    onMouseDown(ev) {
        this.reset();
        this.sketch.scope.activate();
        this.path = new this.sketch.scope.Path();
        const color = new this.sketch.scope.Color("red");
        this.path.set({
            strokeCap: "round",
            strokeJoin: "round",
            strokeColor: color,
            shadowColor: color,
            strokeWidth: 2,
            dashArray: [10, 4],
        });
        this.path.add(ev.point);
        this.selected.add(this.path);
    }
    onMouseDrag(ev) {
        if (!this.path) {
            return;
        }
        this.sketch.scope.activate();
        this.path.add(ev.point);
        for (const path of this.sketch.scope.project.activeLayer.children) {
            if (!this.selected.has(path) && this.path.intersects(path)) {
                this.selected.add(path);
            }
        }
    }
    onMouseUp(ev) {
        if (!this.path) {
            return;
        }
        this.selected.delete(this.path);
        this.sketch.scope.activate();
        const items = [];
        for (const path of this.selected) {
            if (!this.options.onlyOwned || path.data.userId === this.sketch.userId) {
                items.push({
                    id: path.data.id,
                    userId: path.data.userId,
                    userEndpointId: this.sketch.userEndpointId,
                });
                path.remove();
            }
        }
        if (this.onErased && items.length) {
            this.onErased(items);
        }
        this.reset();
    }
    onKeyUp(ev) {
        this.sketch.scope.activate();
        if (ev.key === "escape" && this.path) {
            this.path.remove();
            this.path = null;
            this.selected.clear();
        }
    }
    reset() {
        var _a;
        this.selected.clear();
        (_a = this.path) === null || _a === void 0 ? void 0 : _a.remove();
        this.path = null;
    }
}
//# sourceMappingURL=eraser.js.map